module.exports = __webpack_public_path__ + "img/logo-tds-gray.9113010c.svg";